import { Component, OnDestroy, OnInit } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { Subscription } from "rxjs"
import { CHNode } from "../../models/node.model"
import { BrowsingService } from "../../services/browsing.service"
import { LocalizationService } from "../../services/localization.service"
import { UserService } from "../../services/user.service"
import { ModalService } from "../modal/modal.service"
import { AuthModalComponent } from "../modals/auth-modal/auth-modal.component"
import { StudentLoginModalComponent } from "../modals/student-login-modal/student-login-modal.component"

@Component({
    selector: "app-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, OnDestroy {
    public logoImage: string = null
    public logoImageWhite: string = null
    public logoImageStateWhite: string = null
    public logoImageState: string = null
    public localizationLogo: string = null
    public showTabletSearch = false
    public showBurgerMenu = false
    public showUserMenu = false
    public isStudent = false
    public isHomePage = false
    public stateName: string = null
    public gtmPrefix = "gtm-header-dropdown-"
    public activeNode: CHNode
    public subscriptions: Subscription[] = []
    public fullCommonName: string = "station"
    public nextUrl: string = null

    constructor(
        public userService: UserService,
        private modalService: ModalService,
        private localizationService: LocalizationService,
        private browsingService: BrowsingService,
        private route: ActivatedRoute
    ) {
        this.logoImage = require("../../../assets/pbslm-logo.svg").default
        this.logoImageWhite = require("../../../assets/pbslm-logo-white.svg").default
        this.logoImageStateWhite = require("../../../assets/PBSLM-Logo-Open-Area-Inverse.svg").default
        this.logoImageState = require("../../../assets/PBSLM-Logo-Open-Area.svg").default

        this.isHomePage = window.location.pathname === "/"
    }

    public ngOnInit() {
        this.isStudent = this.userService.hasStudentExperience()
        this.subscriptions.push(
            this.localizationService.localizeData.subscribe((data) => {
                this.localizationLogo = data.getLogo()
                this.fullCommonName = data.fullCommonName
                this.stateName =
                    this.isStudent && !this.isHomePage ? "for students" : data.stateName
            })
        )

        this.subscriptions.push(
            this.browsingService.activeNodeChanged.subscribe((node) => {
                this.activeNode = node
            })
        )

        this.subscriptions.push(
            this.route.params.subscribe((params) => {
                this.showBurgerMenu = false
                this.showUserMenu = false
            })
        )

        this.subscriptions.push(
            this.route.queryParams.subscribe((params) => {
                if (window.location.pathname.includes("signup")) {
                    this.nextUrl = params["next"]
                }
            })
        )
    }

    public ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }

    public toggleMenu(type: string = "burger-menu") {
        if (type === "burger-menu") {
            this.showBurgerMenu = !this.showBurgerMenu
            this.showUserMenu = false
        } else {
            if (this.userService.isLoggedIn()) {
                this.showUserMenu = !this.showUserMenu
                this.showBurgerMenu = false
            } else {
                this.openAuthModal()
            }
        }
    }

    public openAuthModal(): void {
        const data = this.nextUrl
            ? {
                  nextURL: this.nextUrl,
              }
            : {}

        this.modalService.open(this.isStudent ? StudentLoginModalComponent : AuthModalComponent, {
            data,
        })
    }

    public getName(): string {
        if (this.userService.getFirstName()) {
            return this.userService.getFirstName()
        } else {
            // INFO: Agreement: Display "Account" noun when the user has no first name set.
            return "Account"
        }
    }

    public getLogo() {
        return this.stateName ? this.logoImageState : this.logoImage
    }

    public closeRightHandMenus(): void {
        this.showUserMenu = false
        this.showBurgerMenu = false
    }
}
